import React from 'react';

import MotifFormField from '@ey/motif-react-wrapper/FormField';

import Search from '../../CoreWrappers/Search/index';

export default function EYMotifSearch(props) {
	const {
		value,
		placeholder,
		onChange,
		onKeyDown,
		onSearchButtonClick,
		onClear,
		onEnter,
		styleName,
		darkBg,
		searchHoverText,
		hideClearButton,
		items
	} = props;
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			onEnter && onEnter(e);
		}
		onKeyDown && onKeyDown(e);
	};
	return (
		<MotifFormField>
			<Search
				aria-label="Search"
				value={value}
				placeholder={placeholder}
				items={items}
				onChange={onChange}
				onClear={onClear}
				onKeyDown={handleKeyDown}
				onEnter={onEnter}
				onSearchButtonClick={onSearchButtonClick}
				searchButtonTitle={searchHoverText}
				hideClearButton={hideClearButton}
			/>
		</MotifFormField>
	);
}
